import React from 'react';

import Text from '~components/atoms/Text';

import { useAppSelector } from '~redux/hooks';
import { FundTypeEnum, GoldTypeEnum } from '~utils/enums';

import * as Styles from './_paperGoldTable.module.scss';
import CustomSkeleton from '~components/atoms/Skeleton';

const PaperGoldTable = () => {
    const dashboardGoldProductInventory = useAppSelector(state => state.dashboard.dashboardGoldProductInventory);
    const loading = useAppSelector(state => state.dashboard.loadings.getDashboardProductInventory);
    const error = useAppSelector(state => state.dashboard.errors.getDashboardProductInventory);

    const filters = useAppSelector(state => state.dashboard.dashboardGoldProductInventoryFilters);

    const tableHeader = [
        'Denomination',
        'Quantity (pcs)',
        'Total Weight (gram)',
    ];

    const paperGoldInventory = dashboardGoldProductInventory.filter(product => product.goldType === GoldTypeEnum.PaperGold && product.fundType === FundTypeEnum.Islamic);

    const combinedInventory = {
        productName: paperGoldInventory[0]?.productName,
        amount: paperGoldInventory[0]?.paperGoldBlockAmount,
        paperGoldWeight: paperGoldInventory.reduce((acc, product) => acc + product.paperGoldWeight, 0),
    };

    const renderTableHeader = () => {
        return tableHeader.map((header, index) => {
            return (
                <th key={index}>
                    {header}
                </th>
            );
        });
    };

    const renderTableBody = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan={3}>
                        <CustomSkeleton height={40} />
                    </td>
                </tr>
            );
        }

        if (error) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label={error}
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (!paperGoldInventory.length) {
            return (
                <tr>
                    <td colSpan={3}>
                        <Text
                            label='No data found'
                            isError
                        />
                    </td>
                </tr>
            );
        }

        if (filters.branchCode === '') {
            return (
                <tr>
                    <td>{combinedInventory.productName}</td>
                    <td>{combinedInventory.amount}</td>
                    <td>{typeof combinedInventory.paperGoldWeight === 'number' ? combinedInventory.paperGoldWeight.toFixed(3) : '-'}</td>
                </tr>
            );
        }

        return paperGoldInventory.sort((a, b) => a.productId - b.productId).map((product, index) => {
            return (
                <tr key={index}>
                    <td>{product.productName}</td>
                    <td>{product.paperGoldBlockAmount}</td>
                    <td>{typeof product.paperGoldWeight === 'number' ? product.paperGoldWeight.toFixed(3) : '-'}</td>
                </tr>
            );
        });
    };

    return (
        <div className={Styles.container}>
            <Text
                label='Affin Emas Account-I'
                className={Styles.title}
                isBold
            />

            <table className={Styles['table-container']}>
                <thead>
                    <tr>
                        {renderTableHeader()}
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td colSpan={3} />
                    </tr>

                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default PaperGoldTable;
